export default __webpack_public_path__ + "static/media/pinterest-icon.f3c7d65d.svg";